import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Policies.css';

const ChildSafetyPolicy: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className='policy-container'>
            <button className="back-button" onClick={() => navigate(-1)}>
                ← Back
            </button>
            <h1>Child Safety Policy</h1>
            <p className="policy-intro">Last Updated: January 5, 2025</p>

            <section className="child-safety-policy">
                <h2 className="section-title">Age Restriction</h2>

                <div className="content-block">
                    <p>Fervoir is strictly for users aged 18 and older.</p>
                </div>

                <h2 className="section-title">Protection Measures</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>Any profile suspected of belonging to a minor will be immediately removed.</li>
                        <li>Attempts to contact or solicit minors will result in permanent account suspension and legal action.</li>
                        <li>We actively cooperate with law enforcement to address any concerns regarding underage users.</li>
                    </ul>
                </div>
            </section>

            {/* Updates to These Policies Section */}
            <section className="updates-section">
                <h2 className="section-title">Updates to These Policies</h2>

                <div className="content-block">
                    <p>
                        We reserve the right to update these policies at any time.
                    </p>
                    <ul className="list">
                        <li>Significant changes will be communicated to users via the app and/or email.</li>
                        <li>Continued use of Fervoir after changes constitutes acceptance of the new policies.</li>
                    </ul>
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact-section">
                <h2 className="section-title">Contact Us</h2>
                <div className="content-block">
                    <p>For any questions, concerns, or feedback, please contact us at:</p>
                    <p>
                        Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default ChildSafetyPolicy;